import {
  ActivityTrackerEventType,
  BrowseByTypes,
} from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useBreadcrumbTrackingOnClick() {
  const [, currentUser] = useCurrentUser();
  const userId = currentUser?.id;
  const { sendActivityTrackerEvent } = useActivityTracker({ userId });

  return (label: string) => {
    sendActivityTrackerEvent(ActivityTrackerEventType.BROWSE_BY_ACTION, {
      type: BrowseByTypes.BREADCRUMB,
      label,
    });
  };
}
